<template>
  <div class="activities-enroll create-fabu">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="enroll-view">
      <el-form-item label="作品形式" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.workType">
              <el-radio :label="0">图片</el-radio>
              <el-radio :label="1">视频</el-radio>
              <el-radio :label="2">文章</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品名称" prop="title">
        <div class="form-item">
          <div class="right-ipt">
            <el-input
              v-model="ruleForm.title"
              placeholder="请输入作品名称"
              show-word-limit
              :maxlength="30"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品类型" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-cascader
              v-if="ruleForm.workType === 0 || ruleForm.workType === 1"
              style="width: 100%"
              v-model="ruleForm.cascVal"
              :options="cascOptions"
            >
            </el-cascader>
            <el-select
              v-if="ruleForm.workType === 2"
              style="width: 100%"
              v-model="ruleForm.selVal"
              placeholder="请选择"
            >
              <el-option
                v-for="item in selOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品主题" prop="" v-if="ruleForm.workType === 2">
        <div class="form-item">
          <div class="right-ipt">
            <el-select
              style="width: 100%"
              v-model="ruleForm.zhutiVal"
              placeholder="请选择"
            >
              <el-option
                v-for="item in zhutiOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="涉及朝代" prop="" v-if="ruleForm.workType === 2">
        <div class="form-item">
          <div class="right-ipt">
            <el-select
              style="width: 100%"
              v-model="ruleForm.chaodaiVal"
              placeholder="请选择"
            >
              <el-option
                v-for="item in chaodaiOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品简介" prop="">
        <div class="form-item">
          <div class="right-ipt">
            富文本
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品图片" prop="" v-if="ruleForm.workType === 0">
        <div class="form-item">
          <div class="right-ipt">
            <div class="upload-images">
              <div class="upload-item">
                <label>
                  <input type="file" class="up-ipt">
                  <div class="flot">
                    <span class="img-icon"></span>
                    <span class="words">点击上传图片</span>
                  </div>
                </label>
                <!-- <i class="el-icon-close icon-close" title="删除"></i> -->
              </div>
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <el-button class="set-fm-btn" type="danger" size="mini">设为封面</el-button>
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <el-button class="set-fm-btn" type="danger" size="mini">设为封面</el-button>
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <el-button class="set-fm-btn" type="danger" size="mini">设为封面</el-button>
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <el-button class="set-fm-btn" type="danger" size="mini">设为封面</el-button>
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <el-button class="set-fm-btn" type="danger" size="mini">设为封面</el-button>
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品视频" prop="" v-if="ruleForm.workType === 1">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.videoType">
              <el-radio :label="0">本地上传</el-radio>
              <el-radio :label="1">第三方上传</el-radio>
            </el-radio-group>
            <div v-if="ruleForm.videoType === 0">
              <label class="copy-button">
                上传视频
                <input type="file" class="file-input">
              </label>
              <div class="g-tip">请上传视频格式文件,视频最大为2G</div>
              <div class="video-show">
                <div class="video-name">的健康的健身卡</div>
                <div class="btns videoFiles">
                  <i class="el-icon-delete" title="删除"></i>
                </div>
              </div>
            </div>
            <div v-if="ruleForm.videoType === 1">
              <el-input
                type="textarea"
                v-model="ruleForm.otherVideo"
                rows="3"
                placeholder="仅支持添加通用代码，添加视频播放地址无效。"
              />
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品封面" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-button class="fengm-btn" type="danger" @click="showUploadImg">选择图片</el-button>
            <div class="upload-images">
              <div class="upload-item">
                <img class="img-show" :src="require('@/assets/images/upload_demo.jpg')" alt="">
                <i class="el-icon-close icon-close" title="删除"></i>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品标签" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-button type="danger" @click="selectTagsShowEvent">选择标签</el-button>
            <div class="tag-list">
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
              <el-tag size="small" type="success" effect="dark" closable>标签一</el-tag>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="作品来源" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.orgin">
              <el-radio :label="0">原创作品</el-radio>
              <el-radio :label="1">转载分享</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="公开权限" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-radio-group v-model="ruleForm.root">
              <el-radio :label="0">所有人可见</el-radio>
              <el-radio :label="1">仅本人可见</el-radio>
            </el-radio-group>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="@的人" prop="">
        <div class="form-item">
          <div class="right-ipt">
            <el-input
              v-model="ruleForm.aite"
              placeholder="输入想要@人的昵称，以“，”隔开，例：李雷，韩梅梅"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>
      <div class="last-btn">
        <el-button size="medium" type="primary"><i class="el-icon-finished"></i> 保存</el-button>
        <el-button size="medium" type="warning"><i class="el-icon-view"></i> 预览</el-button>
        <el-button size="medium" type="success"><i class="el-icon-s-promotion"></i> 发布作品</el-button>
      </div>
    </el-form>
    <!-- 上传封面弹窗 -->
    <el-dialog
      title="上传图片"
      :visible.sync="dialogUploadImg"
      top="100px"
      :closeOnClickModal="false"
      :width="$store.state.app.device === 'desktop' ? '600px' : '90%'"
      :modal-append-to-body="false"
    >
      <div class="cut-img">
        <div class="cropper-wrap-f">
          <div class="cropper-wrap">
            <vue-cropper
              ref="cropper"
              :img="imgOption.img"
              :fixed="imgOption.fixed"
              :autoCrop="imgOption.autoCrop"
              :autoCropWidth="imgOption.autoCropWidth"
              :autoCropHeight="imgOption.autoCropHeight"
              :outputType="imgOption.outputType"
              :fixed-number="imgOption.fixedNumber"
              mode="cover"
            >
            </vue-cropper>
          </div>
        </div>
        <div class="btns">
          <label class="btn">
            <input
              type="file"
              id="uploads"
              style="position:absolute; clip:rect(0 0 0 0);"
              accept="image/png, image/jpeg, image/gif, image/jpg"
              @change="uploadImgNew($event)"
            />
            {{ imgOption.img === "" ? "选择" : "重新选择" }}图片
          </label>
        </div>
      </div>
      <span slot="footer" class="dialog-footer cut-image">
        <el-button type="info" @click="dialogUploadImg = false"><i class="el-icon-refresh-left"></i> 返回</el-button>
        <el-button type="primary" @click="cutOver"><i class="el-icon-finished"></i> 确定</el-button>
      </span>
    </el-dialog>
    <!-- 选择标签弹窗 -->
    <el-dialog
      title="选择标签"
      :visible.sync="dialogTags"
      :width="$store.state.app.device === 'desktop' ? '500px' : '90%'"
      top="50px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <div class="select-tags-cont">
        <el-button
          class="tag-btn"
          :type="item.active === false ? 'info' : 'danger'"
          v-for="(item, index) in tagList"
          :key="index"
          @click="selectTagsEvent(index)"
        >
          {{item.label}}
        </el-button>
      </div>
      <div style="margin-top: 15px;">
        <el-input placeholder="请输入新标签" v-model="newTagVal" maxlength="10" show-word-limit>
          <el-button slot="append">添加</el-button>
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="selectTagsOver">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
import {VueCropper} from 'vue-cropper'

export default {
  props: {},
  components: {
    VueCropper
  },
  data () {
    return {
      dialogUploadImg: false,
      imgOption: {
        img: '',
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [11, 7], // 截图框比例
        autoCrop: true, // 是否显示截图框
        autoCropWidth: 500, // 截图框默认宽度
        autoCropHeight: 318, // 截图框默认高度
        outputType: 'png' // 图片输出格式
      },
      selOptions: [
        {
          label: '故事',
          value: 0
        },
        {
          label: '哈哈',
          value: 1
        },
        {
          label: '发的',
          value: 2
        }
      ],
      zhutiOptions: [
        {
          label: '中华上下五千年',
          value: 0
        },
        {
          label: '成语故事',
          value: 1
        }
      ],
      chaodaiOptions: [
        {
          label: '神话时代',
          value: 0
        },
        {
          label: '夏商',
          value: 1
        }
      ],
      cascOptions: [
        {
          value: 'zhinan',
          label: '指南',
          children: [
            {
              value: 'shejiyuanze',
              label: '设计原则'
            },
            {
              value: 'daohang',
              label: '导航'
            }
          ]
        },
        {
          value: 'basic',
          label: 'Basic',
          children: [
            {
              value: 'layout',
              label: 'Layout 布局'
            },
            {
              value: 'color',
              label: 'Color 色彩'
            },
            {
              value: 'typography',
              label: 'Typography 字体'
            },
            {
              value: 'icon',
              label: 'Icon 图标'
            },
            {
              value: 'button',
              label: 'Button 按钮'
            }
          ]
        }
      ],
      dialogTags: false,
      tagList: [
        {id: 0, label: '标签一标签一标签一标签一', active: false},
        {id: 1, label: '标签二', active: false},
        {id: 2, label: '标签三', active: false},
        {id: 3, label: '标签四', active: false},
        {id: 4, label: '标签五', active: false},
        {id: 5, label: '标签六', active: false},
        {id: 6, label: '标签七', active: false},
        {id: 7, label: '标签八', active: false},
        {id: 8, label: '标签九', active: false}
      ],
      newTagVal: '',
      ruleForm: {
        workType: 0,
        title: '',
        selVal: 0,
        zhutiVal: 0,
        chaodaiVal: 0,
        cascVal: [],
        videoType: 0,
        otherVideo: '',
        orgin: 0,
        root: 0,
        aite: ''
      },
      rules: {
        title: [{required: true, message: '请输入作品名称', trigger: 'blur'}]
      }
    }
  },
  computed: {},
  mounted () {},
  methods: {
    //显示上传图片弹窗
    showUploadImg () {
      this.dialogUploadImg = true
    },
    uploadImgNew (e) {
      //上传图片
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      var reader = new FileReader()
      reader.onload = (e) => {
        let data
        if (typeof e.target.result === 'object') {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]))
        } else {
          data = e.target.result
        }

        this.imgOption.img = data
      }
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file)
    },
    cutOver () {
      // 输出bolb格式地址
      this.$refs.cropper.getCropBlob((data) => {
        var img = window.URL.createObjectURL(data)
        console.log(img);
      })
      // 输出base64格式
      this.$refs.cropper.getCropData((data) => {
        console.log(data);
      })
    },
    selectTagsShowEvent () {
      this.dialogTags = true
    },
    selectTagsEvent (index) {
      this.tagList[index].active = !this.tagList[index].active
    },
    selectTagsOver () {
      this.dialogTags = false
    },
  }
}
</script>

<style scoped lang="less">
@import "../create.less";
</style>
